// extracted by mini-css-extract-plugin
export var text = "_b6-0";